import {
  MainHubSubmitStakeError,
  StakingError,
  SubmitStakePayload,
} from './types';

import {
  BetError,
  MatchError,
  submitStakeFailure,
  SubmitStakeFailureAction,
  SubmitStakeFailurePayload,
} from 'app/modules/BetSlip/actions/submission';

import { StakeErrorCode } from '../../constants';

// ---

export const createStakingError = (
  status: StakeErrorCode | number,
  limits?: MainHubSubmitStakeError['limits'],
  rejectReason?: MainHubSubmitStakeError['rejectReason'],
): StakingError => {
  return {
    status,
    limits,
    rejectReason,
  };
};

// ---

type FailurePayloadByErrorCode = {
  error: StakingError;
  matchErrors: MatchError[] | null;
  betErrors: BetError[] | null;
};

export const getFailurePayloadByErrorCode = ({
  errorCode = null,
  ...props
}: MainHubSubmitStakeError): FailurePayloadByErrorCode => {
  let error: StakingError;
  let matchErrors: MatchError[] | null = null;
  let betErrors: BetError[] | null = null;

  switch (errorCode) {
    case StakeErrorCode.BID_DECLINED:
    case null: // emulating `422`
      error = createStakingError(StakeErrorCode.BID_DECLINED);

      if (props.matchErrors) {
        matchErrors = props.matchErrors.map(({
          matchId,
          errorCode,
          ...props
        }) => ({
          ...props,
          matchId,
          code: errorCode,
        }));
      }

      if (props.betErrors) {
        betErrors = props.betErrors.map(({
          betId,
          errorCode,
          ...props
        }) => ({
          ...props,
          betId,
          code: errorCode,
        }));
      }
      break;

    default: // unrecognized `errorCode`
      error = createStakingError(errorCode, props.limits, props.rejectReason);
  }

  return { error, matchErrors, betErrors };
};

// ---

export function createFailureAction(
  dialogId: string,
  responseError: MainHubSubmitStakeError,
  requestPayload?: SubmitStakePayload,
): SubmitStakeFailureAction {
  const payload: SubmitStakeFailurePayload = { dialogId, requestPayload };

  const { error, matchErrors, betErrors } = getFailurePayloadByErrorCode(responseError);

  if (matchErrors) {
    payload.matchErrors = matchErrors;
  }
  if (betErrors) {
    payload.betErrors = betErrors;
  }

  return submitStakeFailure(error, payload);
}

// ---

type DefaultResponseError = {
  error: {
    errorCode: StakeErrorCode.INTERNAL_SYSTEM_ERROR;
  };
};

export const createDefaultResponseError = (): DefaultResponseError => ({
  error: { errorCode: StakeErrorCode.INTERNAL_SYSTEM_ERROR },
});
